import clsx from "clsx";
import Link from "next/link";
import { usePathname } from "next/navigation";

import { setUserInteractionDataAttribute } from "@shared/constants";

interface Props {
  href: string;
  icon?: React.ReactNode;
  label: string;
  variant?: "button";
  hiddenOnMobile?: boolean;
  hiddenOnDesktop?: boolean;
}

export default function MenuItem({
  href,
  icon,
  label,
  variant,
  hiddenOnMobile,
  hiddenOnDesktop,
}: Props) {
  const path = usePathname();

  const showInMenuBar = path.includes("resources");

  return (
    <Link
      {...setUserInteractionDataAttribute(
        `site-header_menu-item_${label}_link`,
      )}
      href={href}
      className={clsx("site-header__nav__menu__link", {
        "site-header__nav__menu__link--is-button": variant === "button",
        "hidden-on-mobile": hiddenOnMobile,
        "hidden-on-desktop": hiddenOnDesktop,
      })}
      role="menuitem"
    >
      {icon && icon}
      <div>{label}</div>
    </Link>
  );
}
